var render, staticRenderFns
import script from "./Radar.vue?vue&type=script&lang=js&"
export * from "./Radar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85fd6d36')) {
      api.createRecord('85fd6d36', component.options)
    } else {
      api.reload('85fd6d36', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/Charts/Radar.vue"
export default component.exports